import { EssQuestionValue } from '@/domain/impact-ess/entities/question.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Params = {
  projectId: number;
};

export const getImpactEssResponses = createAppAsyncThunk(
  'impactEss/getImpactEssResponses',
  async (
    params: Params,
    { extra: { impactEssGateway, snackbarGateway } },
  ): Promise<EssQuestionValue[]> => {
    try {
      const responses = await impactEssGateway.getImpactEssResponses(
        params.projectId,
      );
      return responses;
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('Error.server-exchange-error'));
}
